// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_views_dashboard_dashboard_module_ts":"b22831207f59d42d","src_app_views_login_login_module_ts":"9670604fa9a7d0a3","src_app_views_dashboard_pages_reports_reports_module_ts":"e25814a8b04d1959"}[chunkId] + ".js";
};